/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/Edit';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const EditIcon = withMuiAdapter(Base, 'Edit');
